import React from 'react';
import KickImage from 'Reuseables/KickImage';
import Countdown from 'react-countdown-now';
import { IconWrapper } from './styled';
import PendingIcon from '../../images/stopwatch-new.png';
import ErrorIcon from '../../images/icons/error.png';
import TimesUpIcon from '../../images/icons/times-up.png';
import SuccessIcon from '../../images/icons/success.png';
import moment from 'moment';

const getStatusIcon = (paymentStatus, isExpired) => {
  switch(paymentStatus) {
    case 'authorize':
    case 'pending': return PendingIcon;
    case 'expire': return TimesUpIcon;
    case 'capture':
    case 'settlement': return SuccessIcon;
    default: return ErrorIcon;
  }
}

const Icon = props => {
  const expiredAtParsed = moment(props.expiredAt).toISOString();
  return (
    <IconWrapper className={props.className}>
      <KickImage src={getStatusIcon(props.transactionStatus)} role="presentation"/>
      {
        props.transactionStatus  === 'pending' && props.expiredAt?
        <Countdown
          date={expiredAtParsed}
          renderer={({ hours, minutes, seconds, completed })=> (
            <span>
              {completed? '00:00:00':`${hours}:${minutes}:${seconds}`}
            </span>
          )}
          onComplete={props.onExpired}
        />
        :null
      }
    </IconWrapper>
  )
}
export default Icon;